/**
 * Safely filters image URLs to prevent deep links (like whatsapp://, tel://, intent://) 
 * from automatically triggering app launch prompts on mobile browsers when used as image src.
 */
export function getSafeImageUrl(url?: string): string | undefined {
  if (!url) return undefined;
  
  // Clean whitespace
  const cleanUrl = url.trim().toLowerCase();
  
  // Allow empty or data URIs
  if (cleanUrl === '' || cleanUrl.startsWith('data:')) return url;
  
  // Allow safe protocols
  if (cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://') || cleanUrl.startsWith('/')) {
    return url;
  }
  
  // If it's an unrecognized protocol (like whatsapp:, tel:, mailto:), return undefined 
  // to avoid rendering an invalid image that triggers an OS intent.
  return undefined;
}
